<template>
  <div class="dropdown dropdown-suggestion">
    <button class="btn-outline btn btn-xs btn-info dropdown-toggle" id="dropdownMenuSuggestion" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
      <i class="pe-7s-more pe-1x fa-rotate-90"></i>
    </button>
    <ul class="dropdown-menu pe-ul pull-right" aria-labelledby="dropdownMenuSuggestion">
      <li>
        <a role="button" @click="refineSearch(suggestion)" v-bind:title="'Refine current search with ' + suggestion"><i class="pe-7s-search pe-fw"></i> Refine current search</a>
      </li>
      <li>
        <a role="button" @click="onlySearch(suggestion)" v-bind:title="'start new search with ' + suggestion"><i class="pe-7s-search pe-fw"></i> Search only suggestion</a>
      </li>
      <li>
        <a v-if="followSearchId === null" role="button" @click="followSuggestion(suggestion)"><i class="fas fa-star text-info"></i> Monitor suggestion</a>
        <a v-else role="button" @click="unFollowSuggestion(followSearchId)"><i class="far fa-star text-info"></i> UnMonitor suggestion</a>
      </li>
      <li role="separator" class="divider"></li>
      <li>
        <a role="button" @click="addSuggestionToBiblio(suggestion)" v-bind:title="'Add '+ suggestion + ' as new box in the Biblio' ">
          <i class="pe-7s-plus pe-fw"></i> Add to biblio <i v-if="$user.isBasic()" class='fa fa-lock font-bold'></i>
        </a>
      </li>
    </ul>
  </div>
</template>

<style scoped>
  @media (max-width: 768px) {
    .dropdown-suggestion .dropdown-menu{
        max-width: 200px;
        }
   }

  .dropdown-suggestion > ul > li i{
    color: #3498db;
    font-weight: bold;
  }

  .dropdown-suggestion > ul > li a{
    font-size: 12px;
  }

  .dropdown-suggestion > ul > li{
    margin-bottom: 5px;
    font-size: 12px;
  }

</style>
<script>

export default {
  components: {},
  props: ['refineSearch', 'onlySearch', 'addSuggestionToBiblio', 'suggestion', 'followSuggestion', 'unFollowSuggestion',
    'followSearchId'],
  name: 'DropdownSuggestion'
}
</script>



// WEBPACK FOOTER //
// src/components/suggestion/DropdownSuggestion.vue